// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"721257c4","455":"6afbbe8f","977":"60f9424d"}[chunkId] + ".chunk.js";
};